import { callApi } from './api';

class UserProfileService {
  async getUserDetails() {
    return await callApi({ url: '/api/accounts/' });
  }
  async getOrdinationDetails(id) {
    return await callApi({ url: `/api/ordination/${id}/` });
  }
  async getCountriesDetails(id) {
    return await callApi({ url: `/api/countries/${id}/` });
  }
  dataForPost(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if(value!=undefined){
        formData.append(key, value)
      }
    });
    return formData;
  }
  async editUserDetails(data, id) {
    data.birth_date = data.birth_date ? data.birth_date.format('YYYY-MM-DD') : null;
    const userData = this.dataForPost(data);
 
    return await callApi({
      url: `api/accounts/${id}/`,
      method: 'PATCH',
      data: userData
    });
  }
  async editDoctorDetails(data, id) {
    
    //data.birth_date = data.birth_date ? data.birth_date.format('YYYY-MM-DD') : null;
    const userData = this.dataForPost(data);
    return await callApi({
      url: `api/doctors/${id}/`,
      method: 'PATCH',
      data: userData
    });
  }
  async changePassword(data, id) {
    delete data.confirm_password;
    return await callApi({
      url: `api/accounts/${id}/change_password/`,
      method: 'PUT',
      data
    });
  }
}

export const userProfileService = new UserProfileService();
